import * as Yup from "yup";

export const DEVICE_TYPE = {
  GPS: "GPS",
  Wifi: "Wifi",
  // Beacon: "Beacon",
  // Fingerprint: "Fingerprint",
};

export const initialValues = {
  commonTypeName: '',
  commonTypeNameEn: '',
};

const YearAccumulateSchema = Yup.object().shape({
  commonTypeName: Yup.string().required(),
  commonTypeNameEn: Yup.string().required(),
});

export default YearAccumulateSchema;
